"use client";

import MediaProgressBar from "@ui/components/core/MediaProgressBar";
import { useCallback, useState } from "react";
import {
  BoxedAspectRatioVideo,
  BoxedAspectRatioVideoProps,
} from "@ui/components/core/BoxedAspectRatioVideo/BoxedAspectRatioVideo";
import { Subtitles } from "@utilities/subtitles/subtitleTypes";

export interface BoxedAspectRatioVideoPlayerProps {
  className?: string;
  src: string;
  subtitles?: Subtitles;
  boxAspectRatio?: BoxedAspectRatioVideoProps["boxAspectRatio"];
}

export function BoxedAspectRatioVideoPlayer({
  src,
  className = "",
  subtitles,
  boxAspectRatio,
}: BoxedAspectRatioVideoPlayerProps) {
  const [mediaElement, setMediaElement] = useState<HTMLVideoElement | null>(null);
  const [isMuted, setIsMuted] = useState(true);

  const handleVideoRef = useCallback((ref: HTMLVideoElement | null) => {
    setMediaElement(ref);
  }, []);

  const handleMuteToggle = useCallback(() => {
    setIsMuted(prev => !prev);
  }, []);

  const handleMediaClick = useCallback(() => {
    if (!mediaElement) return;

    if (mediaElement.paused) {
      mediaElement.play();
    } else {
      mediaElement.pause();
    }
  }, [mediaElement]);

  return (
    <div className={`${className}`}>
      <BoxedAspectRatioVideo
        src={src}
        isMuted={isMuted}
        onMuteToggle={handleMuteToggle}
        onVideoRef={handleVideoRef}
        onVideoClick={handleMediaClick}
        autoPlay={true}
        subtitles={subtitles}
        boxAspectRatio={boxAspectRatio}
      >
        {/* Progress Bar Overlay */}
        <div className='absolute bottom-32 left-0 right-0'>
          <MediaProgressBar mediaElement={mediaElement} className='h-8' inverse />
        </div>
      </BoxedAspectRatioVideo>
    </div>
  );
}
